import { render, staticRenderFns } from "./MultiDefects.vue?vue&type=template&id=3d7432ff&"
import script from "./MultiDefects.vue?vue&type=script&lang=js&"
export * from "./MultiDefects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports